<template>
    <div class="panel">
        <div class="panel-body">
            <div class="row">
                <div class="col-sm-12">
                    <button @click="add()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px;"><i class="fa fa-plus" aria-hidden="true"></i>添加</button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<ZybaAdd ref="ZybaAdd"></ZybaAdd>
		<ZybaEdit ref="ZybaEdit"></ZybaEdit>
    </div>
</template>
<script>
    import tableMixin from '@/mixins/table.js';
    import ZybaAdd from './ZybaAdd.vue';
    import ZybaEdit from './ZybaEdit.vue'
    export default {
        mixins: [tableMixin],
        name:"ZybaList",
		components: {
			ZybaAdd,
			ZybaEdit
		},
        data:function(){
            return {
                query:{

                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center', 
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'ndm',
                        title: '年度码'
                    },
                    {
                        field: 'zkxx_id',
                        title: '主考学校',
						formatter: (value, row, index)=> {
							return row.zkxxCode+'-'+row.zkxxName;
						}
                    },
                     {
                        field: 'zxjg_id',
                        title: '助学机构',
						formatter: (value, row, index)=> {
							return row.zxjgCode+'-'+row.zxjgName;
						}
                    },
                    {
                        field: 'zymc',
                        title: '专业',
						formatter: (value, row, index)=> {
							return row.zydm + '-' + row.zymc;
						}
                    },
                    {
                        field: 'zt',
                        title: '状态',
                        formatter: (value) => {
                            return value == 'OK' ? '启用' : '禁用';
                        }
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            let btnName=row.zt=='OK' ? '禁用' :'启用';
                            return this.vueFormatter({
                                template: '<div class="operation_column">' +
                                    '<a @click="edit(row)">修改</a> | ' +
                                    '<a @click="enableById(row)">'+btnName+'</a></div>',
                                data: { row },
                                methods: {
                                    edit: this.edit,
                                    enableById:this.enableById
                                }
                            })
                        }
                    }
                ]
            }
        },
      mounted(){
      	this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
      	this.load();
      },
      beforeRouteUpdate(to, from, next){
		this.query = Object.assign(this.query,{current:1,size:10},to.query);
      	this.load();
      	next();
      },
	created:function(){
		this.$store.commit('setBreadcrumb',[{name:'招生管理'},{name:'招生设置'},{name:'专业备案管理'}]);
	},
	methods:{
		//新增班级
		add:function(){
			this.$refs.ZybaAdd.open();
		},
		//修改
		edit:function (row) {
			this.$refs.ZybaEdit.open({ id:row.id});
		},
		//启用禁用
		enableById:function (row) {
			let id= row.id;
			let zt = row.zt=='OK' ? 'BLOCK' : 'OK';
			this.$confirm('确定进行此操作吗？',()=>{
				this.$http.post("/htgl/biz/specialtyBackup/enableById",{id:id,zt:zt}).then((res)=>{
					if(res.data){
						this.$success('操作成功',()=>{
							this.load();
						});
					}
				});
			});
		},
		//根据查询条件进行检索
		 search:function(){
			 //将数据表格的页码以及每一页展示的数据重置为1，10
			let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
			this.$router.push({name:this.$route.name,query:query});
		 },
		load:function(pageNumber, pageSize){
			this.query.current = pageNumber || this.query.current;
			this.query.size = pageSize || this.query.size;
			this.$http.post('/htgl/biz/specialtyBackup/list',this.query).then(res=>{
				let data = res.data;
				//封装返回值
				let result= {
					total: data.total,
					rows: data.records
				};
				//table加载返回的数据
				this.$refs.table.load(result);
				this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
					pageSize:parseInt(this.query.size)});
			});
		},
		 pageChange:function(pageNumber, pageSize){
			let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
			this.$router.push({name:this.$route.name,query:query});
		 }
	}
   }
</script>
<style scoped>

</style>